function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.6673 25.3334H6.66732V9.33335H11.334C11.702 9.33335 12.0007 9.03469 12.0007 8.66669V4.00002H25.334V12.6667C25.334 13.0347 25.6326 13.3334 26.0006 13.3334C26.3686 13.3334 26.6673 13.0347 26.6673 12.6667V3.33335C26.6673 2.96402 26.3686 2.66669 26.0006 2.66669H11.334C11.2447 2.66669 11.158 2.68402 11.078 2.71869C10.9967 2.75202 10.9233 2.80135 10.862 2.86269L5.52998 8.19469C5.46865 8.25602 5.41932 8.32802 5.38598 8.40935C5.35265 8.49069 5.33398 8.57735 5.33398 8.66669V26C5.33398 26.368 5.63265 26.6667 6.00065 26.6667H12.6673C13.0353 26.6667 13.334 26.368 13.334 26C13.334 25.632 13.0353 25.3334 12.6673 25.3334ZM7.60998 8.00002L10.6673 4.94269V8.00002H7.60998ZM30.4724 24.196C30.2138 23.936 29.7911 23.932 29.5298 24.1934L24.0004 29.6894V16.6667C24.0004 16.2987 23.7018 16 23.3338 16C22.9658 16 22.6671 16.2974 22.6671 16.6667V29.772L17.0538 24.1934C16.7938 23.9334 16.3711 23.9347 16.1111 24.196C15.8524 24.4574 15.8538 24.88 16.1138 25.1387L22.8218 31.8054C22.9524 31.9347 23.1218 32 23.2924 32C23.4631 32 23.6324 31.936 23.7631 31.8054L30.4711 25.1387C30.7311 24.88 30.7324 24.4574 30.4724 24.196ZM8.01021 17.3334V10.6667H11.3035L12.0009 11.292V13.7747L11.2435 14.4174H9.33288V17.3334H8.01021ZM9.33288 13.3667H10.6342V11.7507H9.33288V13.3667ZM17.334 16.7334V11.284L16.4913 10.6667H13.334V17.3334H16.6247L17.334 16.7334ZM15.9767 16.192H14.6913V11.7507H15.9767V16.192ZM22.6673 10.6667V11.7507H19.97V13.184H21.494V14.3827H19.97V17.3334H18.6673V10.6667H22.6673Z",
  fill: "#848999"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.5d6da865.svg";
export { ForwardRef as ReactComponent };